var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary p-1"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveZums($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("ZUM")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "id": "searchMaterial",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat materiál",
      "open-direction": "bottom",
      "options": _vm.materials,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": "",
      "data-testid": 'visit-zum-search-' + _vm.actionId
    },
    on: {
      "search-change": _vm.getMaterials,
      "select": _vm.selectMaterial
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.label))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Množství")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zum.amount),
      expression: "zum.amount"
    }],
    staticClass: "form-control mr-sm-2 form-control-sm col-sm-1",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "max": "999",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "data-testid": 'visit-zum-amount-' + _vm.actionId
    },
    domProps: {
      "value": (_vm.zum.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zum.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.zumPending) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addZumsButton",
      "data-testid": 'visit-zum-add-' + _vm.actionId
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15827e59","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/AddZum.vue
// module id = 520
// module chunks = 0